import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { saveDesignerUiAccessEmail } from "@/lib/designerUiAccess";

/**
 * Configuración persistente del correo autorizado para ver el módulo Diseñador en la UI.
 * Visible solo para quien puede editar (correo autorizado actual o cuenta diseñador backdoor).
 */
export default function DesignerUiAccessConfig({ initialEmail, onSaved }) {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await saveDesignerUiAccessEmail(email.trim());
      toast.success("Correo autorizado actualizado");
      onSaved?.(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "No se pudo guardar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      onSubmit={onSave}
      className="rounded-sm border border-violet-200 bg-violet-50/50 p-4 space-y-3"
      data-testid="designer-ui-access-config"
    >
      <div>
        <h3 className="text-sm font-semibold text-[#0F2D5C]">Configuración de acceso</h3>
        <p className="text-[11px] text-slate-600 mt-1 leading-snug">
          Solo el usuario con este correo verá el módulo <strong>Diseñador</strong> en el Panel General.
          El cambio es persistente en el servidor.
        </p>
      </div>
      <div>
        <Label className="text-xs">Correo autorizado como Diseñador</Label>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 rounded-sm font-mono text-sm"
          required
          data-testid="designer-ui-access-email-input"
        />
      </div>
      <Button
        type="submit"
        disabled={busy || !email.trim()}
        className="rounded-sm bg-[#0F2D5C] hover:bg-[#0a2248] h-9 text-xs"
        data-testid="designer-ui-access-save-btn"
      >
        Guardar correo autorizado
      </Button>
    </form>
  );
}
